module.exports = __webpack_public_path__ + "static/media/Pago aprobado.d7e4e332.svg";